import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { UrlCollectionSarang } from '../../../common/url-collection-sarang';
import * as cuisineOrderManagementAction from "../../../redux/store-sarang/cuisine-order/cuisine-order-management.store";
import { NotificationMessageType } from "../../../utils/configuration";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import LoadingViewAria from '../../../components/layout-sarang/loading-view-aria'
import CookingRegisterChart from '../../../pages/dashboard-home/component/dashboard-cooking-register/cooking-register-chart';
import viVN from "../../../language/vi-VN.json";
import dayjs from 'dayjs';
import Select from "react-select";
import * as branchManagementAction from "../../../redux/store-sarang/branch/branch-management.store";
import * as accountManagementAction from "../../../redux/store/account/account.store";

export default function CuisineOrderNumberWidget() {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);
    const [branch, setBranch] = useState([]);
    const [currentBranchId, setCurrentBranchId] = useState(null);
    const [userBranchId, setUserBranchId] = useState(null);
    const [now] = useState(new Date());
    const listMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    const getSumaryByDateCuisineOrder = useCallback(async (branchId = undefined) => {
        setLoading(true);
        try {
            const res = await cuisineOrderManagementAction.SumaryByDateCuisineOrder(dayjs(now).format(), dayjs(now).format(), branchId);
            if (res && res.content) {
                setData(res.content);
            }
        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(
                    viVN.Errors[err.errorType],
                    NotificationMessageType.Error
                );
            }
        } finally {
            setLoading(false);
        }
    }, [now]);

    useEffect(() => {
        const init = async () => {
            try {
                const resB = await branchManagementAction.GetLookupBranch();
                if (resB && resB.content) {
                    setBranch(resB.content);
                }

                const resU = await accountManagementAction.GetDetailAcc();
                let branchId = null;
                if (resU && resU.content) {
                    branchId = resU.content.branchId;
                    if (branchId) {
                        setCurrentBranchId(branchId);
                        setUserBranchId(branchId);
                    }
                }
                getSumaryByDateCuisineOrder(branchId);
            } catch (err) {
                getSumaryByDateCuisineOrder();
            }
        };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <div className="card row">
                <div className="card-header d-flex align-items-center">
                    <h5 className="mb-0">Suất ăn ngày {dayjs(now).format("DD/MM/YYYY")}</h5>
                    <div className="ml-auto" style={{ width: '250px' }}>
                        <Select
                            isClearable
                            value={branch?.map(item => ({ label: item.name, value: item.id })).find(x => x.value === currentBranchId) || null}
                            onChange={(data) => {
                                const bid = data ? data.value : null;
                                setCurrentBranchId(bid);
                                getSumaryByDateCuisineOrder(bid);
                            }}
                            placeholder="Chọn Chi hội"
                            options={branch?.map(item => ({ label: item.name, value: item.id }))}
                            noOptionsMessage={() => "Không tồn tại"}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        />
                    </div>
                </div>
                <div className="row card-body">
                    <div className={userBranchId === 3 ? "col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12" : "col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12"}>
                        <div className="card">
                            <div className="card-body">
                                <div className="d-inline-block">
                                    <h5 className="text-muted">Tổng</h5>
                                    <h3 className="mb-0 text-info"><b>{data.length > 0 ? data[0].numberMealSetLunch + data[0].numberMealSetDinner + " - Trưa: " + data[0].numberMealSetLunch + " - Chiều: " + data[0].numberMealSetDinner : 0}</b></h3>
                                </div>
                                <div className="float-right icon-circle-medium  icon-box-lg  bg-info-light mt-1">
                                    <i className="fas fa-birthday-cake fa-fw fa-sm text-info"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={userBranchId === 3 ? "col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12" : "col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12"}>
                        <div className="card">
                            <div className="card-body">
                                <div className="d-inline-block">
                                    <h5 className="text-muted">Nam</h5>
                                    <h3 className="mb-0 text-primary"><b>{data.length > 0 ? data[0].manNumberMealSetLunch + data[0].manNumberMealSetDinner + " - Trưa: " + data[0].manNumberMealSetLunch + " - Chiều: " + data[0].manNumberMealSetDinner : 0}</b></h3>
                                </div>
                                <div className="float-right icon-circle-medium  icon-box-lg  bg-primary-light mt-1">
                                    <i className="fas fa-male fa-fw fa-sm text-primary">
                                    </i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={userBranchId === 3 ? "col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12" : "col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12"}>
                        <div className="card">
                            <div className="card-body">
                                <div className="d-inline-block">
                                    <h5 className="text-muted">Nữ</h5>
                                    <h3 className="mb-0 text-secondary"><b>{data.length > 0 ? data[0].womanNumberMealSetLunch + data[0].womanNumberMealSetDinner + " - Trưa: " + data[0].womanNumberMealSetLunch + " - Chiều: " + data[0].womanNumberMealSetDinner : 0}</b></h3>
                                </div>
                                <div className="float-right icon-circle-medium  icon-box-lg bg-secondary-light mt-1">
                                    <i className="fas fa-female fa-fw fa-sm text-secondary"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    {userBranchId === 3 && (
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-inline-block">
                                        <h5 className="text-muted">Ăn tại nhà hàng</h5>
                                        <h3 className="mb-0 text-success"><b>{data.length > 0 ? data[0].eatAtRestaurantLunch + data[0].eatAtRestaurantDinner + " - Trưa: " + data[0].eatAtRestaurantLunch + " - Chiều: " + data[0].eatAtRestaurantDinner : 0}</b></h3>
                                    </div>
                                    <div className="float-right icon-circle-medium  icon-box-lg bg-success-light mt-1">
                                        <i className="fas fa-utensils fa-fw fa-sm text-success"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <LoadingViewAria loading={loading} />
            </div>
            <div className="card row">
                <CookingRegisterChart listMonth={listMonth} />
            </div>
        </>
    )
}